import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const HomePage = () => {

  return (
    <div className="h-screen flex flex-col w-full">
      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center w-full bg-gray-50 py-8 sm:py-12 mb-8 full-viewport-width">
        <div className="w-full px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-8 xl:gap-16 items-center">
            {/* Left Side - Company Info */}
            <div className="space-y-4 sm:space-y-6">
              <div className="flex items-center space-x-2 sm:space-x-3 mb-4 sm:mb-6">
                <img src="/Logo.png" alt="Enpact Logo" className="h-12 w-auto sm:h-16" />
                <div>
                  <h1 className="text-2xl sm:text-3xl font-bold text-enpact-red">Enpact</h1>
                  <p className="text-base sm:text-lg text-quickbooks-gray-dark">Revenue Stream Calculator</p>
                </div>
              </div>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
                Access the Enpact Platform wherever you are
              </h2>
              <p className="text-base sm:text-lg text-quickbooks-gray-dark leading-relaxed">
                Financial professionals need constant access to high-quality revenue calculations and analytics. 
                Enpact keeps you connected from virtually anywhere, from any type of device.
              </p>
            </div>

            {/* Right Side - Login/Get Started */}
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg border border-gray-200">
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-6 text-center">
                Log into your Enpact Platform
              </h3>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Username
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-enpact-red focus:border-transparent"
                    placeholder="Enter your username"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Password
                  </label>
                  <input
                    type="password"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-enpact-red focus:border-transparent"
                    placeholder="Enter your password"
                  />
                </div>
                <div className="text-right">
                  <a href="#" className="text-sm text-enpact-red hover:underline">
                    Forgot password?
                  </a>
                </div>
                <Link
                  to="/dashboard"
                  className="w-full bg-enpact-red text-white py-3 px-4 rounded-md hover:bg-enpact-red-dark transition-colors duration-200 text-center font-medium block"
                >
                  LOG IN
                </Link>
              </div>
              <div className="mt-6 text-center text-sm text-gray-600">
                <p>Need help? <a href="#" className="text-enpact-red hover:underline">Contact us</a></p>
                <p className="mt-2">Not a user? <a href="#" className="text-enpact-red hover:underline">Request access</a></p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>

      {/* Footer */}
      <div className="mt-auto">
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
